/**
 * Palette and series shape, kept out of `../components/dashboard-chart-card`
 * so the dashboard page can build its series without statically importing
 * recharts (~744 KB) — the card itself is lazy-loaded.
 */

export const DEFAULT_ACCENT = 'var(--color-riso-blue, #1d5fa7)';
// Order matters: teal→amber→blue→pink is the only riso ordering passing both
// CVD adjacent-ΔE separation and normal-vision floor (adjacent series become
// adjacent stacked segments). Do not reorder to blue-first.
export const SERIES_COLORS = [
  'var(--color-riso-teal, #157a6e)',
  'var(--color-riso-amber, #b57a32)',
  'var(--color-riso-blue, #1d5fa7)',
  'var(--color-riso-pink, #a05b7b)',
];

// A wider categorical palette for pies, where every visible entity is a
// separate slice. The first four stay aligned with the dashboard time-series
// palette; the remaining colors avoid adjacent repeats for the top-eight view.
export const PIE_COLORS = [
  ...SERIES_COLORS,
  '#6a8f4e',
  '#7c62a3',
  '#c2633c',
  '#4f8a9e',
];

export function pieColorForSlice(key: string, index: number): string {
  if (key === '__other__') return 'var(--color-muted-foreground, #6b7280)';
  return PIE_COLORS[index % PIE_COLORS.length];
}

export interface ChartSeries {
  /** Key into each ChartRow: 'value' for single-series, currency code for multi. */
  dataKey: string;
  color: string;
  /** ISO code used to format this series' values in the tooltip. */
  currency: string;
  /** Legend/tooltip label; defaults to currency. */
  label?: string;
}
